export const teacherTitleList = ['Ms.', 'Mr.', 'Mrs.', 'Miss', 'Dr.'];
export const teacherNamesMaxLength = 32;